import { OTP_FLOW } from '../utils/constants.json';

const INITIAL_STATE = {
  pgMid: '',
  deviceSerialNumber: '',
  empid: '',
};

/**
 * Reducer - to update services state
 * @param {Object} state initial/default services state.
 * @param {Object} action to be performed
 * @return {Object} new services state
 */
export default function (state = INITIAL_STATE, action) {
  const { payload } = action;
  switch (action.type) {
    case OTP_FLOW.SUCCESS:
      return { ...state, ...payload };
    default:
      return { ...state };
  }
}
